import { useModal } from '@billy/design-system'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { ModalId } from '../enums/modalId'
import { useSegment } from '../hooks'
import { reactRoute } from '../utils/routing/reactRoute'
import { useOrganizationViewUrl } from './routing/useOrganizationViewUrl'
import { useIsHelpCenterEnabled } from './useIsHelpCenterEnabled'

interface UseOpenHelpCenterResult {
  isHelpCenterEnabled: boolean
  openHelp: () => void
}

export const useOpenHelpCenter = (): UseOpenHelpCenterResult => {
  const navigate = useNavigate()
  const { url: helpCenterUrl } = useOrganizationViewUrl(reactRoute.organization.helpCenter.getMainRoute())
  const { track } = useSegment()

  const { isHelpCenterEnabled } = useIsHelpCenterEnabled()

  const handleOpen = useCallback(() => {
    track('xxx-help-modal-open')
  }, [track])

  const handleClose = useCallback(() => {
    track('xxx-help-modal-close')
  }, [track])

  const { open: openModal } = useModal(ModalId.HelpModal, { onOpen: handleOpen, onClose: handleClose })

  const openHelp = useCallback(() => {
    if (isHelpCenterEnabled && helpCenterUrl) {
      navigate(helpCenterUrl)
    } else {
      openModal()
    }
  }, [isHelpCenterEnabled, helpCenterUrl, navigate, openModal])

  return { isHelpCenterEnabled, openHelp }
}
